import React, { useState, useMemo } from 'react';

const HelpIcon = ({ text }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: rect.right + 10, y: rect.top - 10 });
    setShowPopup(true);
  };
  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <span onMouseEnter={handleMouseEnter} onMouseLeave={() => setShowPopup(false)} style={{ display: 'inline-block', marginLeft: '6px', width: '18px', height: '18px', backgroundColor: '#0066cc', color: 'white', borderRadius: '50%', textAlign: 'center', lineHeight: '18px', fontSize: '12px', fontWeight: 'bold', cursor: 'help' }}>?</span>
      {showPopup && <div onMouseEnter={() => setShowPopup(true)} onMouseLeave={() => setShowPopup(false)} style={{ position: 'fixed', top: `${position.y}px`, left: `${position.x}px`, background: '#1e293b', border: '2px solid #0066cc', borderRadius: '8px', padding: '12px 16px', maxWidth: '280px', color: '#e5e7eb', fontSize: '13px', lineHeight: '1.5', zIndex: 9999, boxShadow: '0 8px 24px rgba(0,0,0,0.6)', pointerEvents: 'auto' }}>{text}</div>}
    </div>
  );
};

const ProductModal = ({ product, onClose, onSelect }) => {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#1e293b', border: '2px solid #0066cc', borderRadius: '12px', padding: '20px', maxWidth: '500px', width: '90%', color: '#e5e7eb', boxShadow: '0 10px 40px rgba(0,0,0,0.8)' }} onClick={e => e.stopPropagation()}>
        <div style={{ width: '100%', height: '180px', background: product.color, borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px' }}>{product.image}</div>
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#10b981' }}>{product.name}</h3>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#94a3b8' }}>{product.brand}</p>
        <div style={{ fontSize: '13px', color: '#e5e7eb', marginBottom: '16px', lineHeight: '1.6' }}>
          <div>⚡ COP: {product.cop}</div>
          <div>📋 Warranty: {product.warranty} years</div>
          <div>💰 Cost: £{product.cost.toLocaleString()}</div>
          <div>🎁 Grant: £{product.grant.toLocaleString()}</div>
          <div style={{ marginTop: '12px', color: '#94a3b8' }}>{product.description}</div>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { onSelect(product); onClose(); }} style={{ flex: 1, background: '#10b981', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer', fontWeight: 500 }}>Select This</button>
          <button onClick={onClose} style={{ flex: 1, background: '#334155', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

const hpProducts = {
  air: {
    low: [
      { name: 'Mitsubishi MSZ', brand: 'Mitsubishi', cop: '3.2', warranty: 5, cost: 8500, grant: 7500, color: '#3b82f6', image: '❄️ Mitsubishi', description: 'Budget air source. Reliable performance. Standard features.' },
      { name: 'Daikin FTXS', brand: 'Daikin', cop: '3.1', warranty: 5, cost: 8200, grant: 7500, color: '#6366f1', image: '❄️ Daikin', description: 'Entry-level air source. Good efficiency.' },
      { name: 'LG Therma', brand: 'LG', cop: '3.3', warranty: 5, cost: 8800, grant: 7500, color: '#8b5cf6', image: '❄️ LG', description: 'Budget option. Solid build quality.' }
    ],
    medium: [
      { name: 'Mitsubishi MSZ Premium', brand: 'Mitsubishi', cop: '3.6', warranty: 7, cost: 10500, grant: 7500, color: '#06b6d4', image: '❄️ Mitsubishi', description: 'Mid-range air source. Most popular. Best value.' },
      { name: 'Daikin Altherma', brand: 'Daikin', cop: '3.7', warranty: 7, cost: 10800, grant: 7500, color: '#10b981', image: '❄️ Daikin', description: 'Premium mid-range. High efficiency.' },
      { name: 'Panasonic Aquarea', brand: 'Panasonic', cop: '3.5', warranty: 7, cost: 10600, grant: 7500, color: '#14b8a6', image: '❄️ Panasonic', description: 'Japanese engineering. Reliable.' }
    ],
    premium: [
      { name: 'Mitsubishi Ecodan', brand: 'Mitsubishi', cop: '4.1', warranty: 10, cost: 12500, grant: 7500, color: '#f59e0b', image: '❄️ Mitsubishi', description: 'Premium air source. Maximum efficiency. Top warranty.' },
      { name: 'Daikin Altherma 3H', brand: 'Daikin', cop: '4.2', warranty: 10, cost: 12800, grant: 7500, color: '#f97316', image: '❄️ Daikin', description: 'Highest efficiency air source. Best in class.' },
      { name: 'Nibe F2040', brand: 'Nibe', cop: '4.0', warranty: 10, cost: 12300, grant: 7500, color: '#fb923c', image: '❄️ Nibe', description: 'Swedish engineering. Premium option.' }
    ]
  },
  ground: {
    low: [
      { name: 'IVT Ground', brand: 'IVT', cop: '4.5', warranty: 7, cost: 18000, grant: 7500, color: '#3b82f6', image: '🌍 IVT', description: 'Budget ground source. Requires borehole.' },
      { name: 'Nibe F1355', brand: 'Nibe', cop: '4.4', warranty: 7, cost: 17800, grant: 7500, color: '#6366f1', image: '🌍 Nibe', description: 'Entry-level ground loop system.' },
      { name: 'Kensa Loop', brand: 'Kensa', cop: '4.3', warranty: 7, cost: 17500, grant: 7500, color: '#8b5cf6', image: '🌍 Kensa', description: 'UK-made ground source.' }
    ],
    medium: [
      { name: 'IVT Ground Premium', brand: 'IVT', cop: '4.8', warranty: 10, cost: 20000, grant: 7500, color: '#06b6d4', image: '🌍 IVT', description: 'Mid-range ground source. 25+ year life.' },
      { name: 'Nibe F2130', brand: 'Nibe', cop: '4.7', warranty: 10, cost: 20500, grant: 7500, color: '#10b981', image: '🌍 Nibe', description: 'Premium Swedish ground loop.' },
      { name: 'Baxi Megaflo', brand: 'Baxi', cop: '4.6', warranty: 10, cost: 19800, grant: 7500, color: '#14b8a6', image: '🌍 Baxi', description: 'Integrated heating. Ground source.' }
    ],
    premium: [
      { name: 'Nibe F2250', brand: 'Nibe', cop: '5.0', warranty: 15, cost: 22000, grant: 7500, color: '#f59e0b', image: '🌍 Nibe', description: 'Premium ground source. Highest efficiency. 5.0 COP.' },
      { name: 'IVT Ground Supreme', brand: 'IVT', cop: '4.9', warranty: 15, cost: 21500, grant: 7500, color: '#f97316', image: '🌍 IVT', description: 'Ultimate ground loop efficiency.' },
      { name: 'Kensa DesignFlex', brand: 'Kensa', cop: '4.85', warranty: 15, cost: 21000, grant: 7500, color: '#fb923c', image: '🌍 Kensa', description: 'UK premium. 30+ year design life.' }
    ]
  }
};

export default function HeatPumpCalculator() {
  const [inputs, setInputs] = useState({ postcode: 'SW1A1AA', homeSize: 3, currentHeating: 'gas', insulationLevel: 'average', radiatorSize: 'standard', includeBus: true });
  const [hpType, setHpType] = useState('air');
  const [selectedTier, setSelectedTier] = useState('medium');
  const [selectedProduct, setSelectedProduct] = useState(hpProducts.air.medium[0]);
  const [showModal, setShowModal] = useState(null);

  const regionMap = { 'SW': 1.0, 'SE': 1.12, 'E': 1.05, 'N': 0.95, 'NW': 0.95, 'M': 1.0, 'W': 0.98, 'WM': 0.98, 'EE': 1.02, 'Y': 0.95, 'NE': 0.92, 'SC': 0.95, 'WA': 0.95, 'EW': 0.95, 'GL': 1.0 };
  const regionCode = inputs.postcode.substring(0, 2).toUpperCase();
  const regionMultiplier = regionMap[regionCode] || 1.0;

  const baseSystemCost = selectedProduct.cost * regionMultiplier;
  let radiatorCost = 0;
  if (inputs.radiatorSize === 'upgrade') radiatorCost = 4500;
  else if (inputs.radiatorSize === 'partial') radiatorCost = 2000;
  
  const microbore = inputs.radiatorSize === 'upgrade' ? 3500 : 1500;
  const installationCost = 2500;
  
  const totalCost = Math.round(baseSystemCost + radiatorCost + microbore + installationCost);
  const busGrant = inputs.includeBus ? selectedProduct.grant : 0;
  const netCost = totalCost - busGrant;

  const projections = useMemo(() => {
    const cop = parseFloat(selectedProduct.cop);
    const gasBoilerCost = 1.50;
    const ashpCost = gasBoilerCost / cop;
    const annualSavings = Math.round((gasBoilerCost - ashpCost) * (inputs.homeSize * 12000) / 100);
    const payback = netCost / Math.max(1, annualSavings);
    const savings25yr = annualSavings * 25;
    
    return { annualSavings, payback: Math.round(payback), savings25yr: Math.round(savings25yr) };
  }, [selectedProduct, inputs.homeSize, netCost]);

  const handleInputChange = (key, value) => { setInputs(prev => ({ ...prev, [key]: value })); };

  return (
    <div>
      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>System Setup <HelpIcon text="Air source = outdoor unit only. Ground source = requires borehole drilling." /></h3>
        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">Heat Pump Type <HelpIcon text="Air = cheaper, faster install. Ground = more efficient." /></label>
            <select className="solar-input" value={hpType} onChange={(e) => { setHpType(e.target.value); setSelectedProduct(hpProducts[e.target.value][selectedTier][0]); }}>
              <option value="air">Air Source (cheaper)</option>
              <option value="ground">Ground Source (more efficient)</option>
            </select>
          </div>
          <div className="solar-input-group">
            <label className="solar-label">Postcode <HelpIcon text="UK postcode for regional labor costs." /></label>
            <input type="text" className="solar-input" value={inputs.postcode} onChange={(e) => handleInputChange('postcode', e.target.value.toUpperCase())} placeholder="e.g., SW1A1AA" />
          </div>
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Select Heat Pump Tier</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '1rem' }}>
          {['low', 'medium', 'premium'].map(tier => (
            <div key={tier} onClick={() => { setSelectedTier(tier); setSelectedProduct(hpProducts[hpType][tier][0]); }} style={{ background: selectedTier === tier ? '#0066cc' : '#334155', border: '2px solid ' + (selectedTier === tier ? '#10b981' : '#475569'), borderRadius: '8px', padding: '12px', cursor: 'pointer', textAlign: 'center', color: '#e5e7eb', fontWeight: selectedTier === tier ? 600 : 400 }}>
              <div style={{ textTransform: 'uppercase', fontSize: '14px' }}>{tier}</div>
            </div>
          ))}
        </div>

        <h4 style={{ margin: '1rem 0 0.5rem', fontSize: '14px', color: '#94a3b8' }}>Featured Products - {selectedTier.toUpperCase()}</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
          {hpProducts[hpType][selectedTier].map((product, i) => (
            <div key={i} onClick={() => setShowModal(product)} style={{ background: '#334155', border: '1px solid #475569', borderRadius: '8px', padding: '12px', cursor: 'pointer', textAlign: 'center' }}>
              <div style={{ width: '100%', height: '100px', background: product.color, borderRadius: '6px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>{product.image}</div>
              <div style={{ fontSize: '12px', fontWeight: 500, color: '#e5e7eb' }}>{product.brand}</div>
              <div style={{ fontSize: '11px', color: '#94a3b8' }}>COP {product.cop} • {product.warranty}yr</div>
              <button onClick={(e) => { e.stopPropagation(); setShowModal(product); }} style={{ marginTop: '8px', width: '100%', background: '#0066cc', border: 'none', borderRadius: '6px', padding: '6px', color: 'white', fontSize: '11px', cursor: 'pointer' }}>View Details</button>
            </div>
          ))}
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Installation Details</h3>
        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">Home size (bedrooms) <HelpIcon text="Determines heating demand." /></label>
            <select className="solar-input" value={inputs.homeSize} onChange={(e) => handleInputChange('homeSize', parseInt(e.target.value))}>
              <option value="1">1 bedroom</option>
              <option value="2">2 bedrooms</option>
              <option value="3">3 bedrooms</option>
              <option value="4">4 bedrooms</option>
              <option value="5">5+ bedrooms</option>
            </select>
          </div>
          <div className="solar-input-group">
            <label className="solar-label">Radiator upgrade <HelpIcon text="Most systems need larger radiators." /></label>
            <select className="solar-input" value={inputs.radiatorSize} onChange={(e) => handleInputChange('radiatorSize', e.target.value)}>
              <option value="standard">Standard sizing (no upgrade)</option>
              <option value="partial">Partial upgrade (£2,000)</option>
              <option value="upgrade">Full upgrade (£4,500)</option>
            </select>
          </div>
        </div>
        <label>
          <input type="checkbox" checked={inputs.includeBus} onChange={(e) => handleInputChange('includeBus', e.target.checked)} />
          <span style={{ marginLeft: '8px', fontSize: '14px' }}>Apply £7,500 BUS grant?</span>
        </label>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Total Cost</h3>
        <div style={{ marginBottom: '1.5rem' }}>
          <div className="solar-row">
            <span>Heat pump unit ({selectedProduct.brand})</span>
            <span className="solar-currency">£{Math.round(baseSystemCost).toLocaleString()}</span>
          </div>
          {inputs.radiatorSize !== 'standard' && <div className="solar-row"><span>Radiator upgrades</span><span className="solar-currency">£{radiatorCost.toLocaleString()}</span></div>}
          <div className="solar-row">
            <span>Microbore repiping</span>
            <span className="solar-currency">£{microbore.toLocaleString()}</span>
          </div>
          <div className="solar-row">
            <span>Installation & commissioning</span>
            <span className="solar-currency">£{installationCost.toLocaleString()}</span>
          </div>
          <div style={{ borderTop: '2px solid #334155', paddingTop: '12px', marginTop: '12px' }}>
            <div className="solar-row" style={{ fontSize: '16px', fontWeight: 600, color: '#fff' }}>
              <strong>Subtotal</strong>
              <span className="solar-currency"><strong>£{totalCost.toLocaleString()}</strong></span>
            </div>
            {inputs.includeBus && <div className="solar-row" style={{ fontSize: '14px', color: '#10b981' }}>
              <strong>BUS Grant</strong>
              <span style={{ color: '#10b981' }}>−£{busGrant.toLocaleString()}</span>
            </div>}
            <div className="solar-row" style={{ fontSize: '16px', fontWeight: 600, color: '#10b981', marginTop: '8px' }}>
              <strong>NET COST</strong>
              <span className="solar-currency"><strong>£{netCost.toLocaleString()}</strong></span>
            </div>
          </div>
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>25-Year Projection</h3>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Annual savings</div>
            <div className="solar-currency" style={{ fontSize: '22px' }}>£{projections.annualSavings.toLocaleString()}</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">Payback</div>
            <div className="solar-metric-value">{projections.payback} yrs</div>
          </div>
        </div>
        <div className="solar-metric" style={{ marginTop: '12px' }}>
          <div className="solar-metric-label">25-Year savings</div>
          <div className="solar-currency" style={{ fontSize: '28px' }}>£{projections.savings25yr.toLocaleString()}</div>
        </div>
      </div>

      {showModal && <ProductModal product={showModal} onClose={() => setShowModal(null)} onSelect={(p) => setSelectedProduct(p)} />}
    </div>
  );
}